<!-- Begin WebApp tabs -->
<ng-container *ngIf="initialized">


<div soho-tabs
    class="is-personalizable"
    headerTabs="true"
    [disableAutoUpdatedCall]="false"
    (afterActivated)="onTabActivated($event)">

  <div soho-tab-list-container id="header-tabs">
    <ul soho-tab-list *ngIf="displayDataGrid">
      <li soho-tab>
        <a soho-tab-title tabId="{{TAB_ID_ALLREPORTS}}" data-automation-id="lm-reports-catalog-allreports-tab">{{catalogTabTitle}}</a>
      </li>
      <li soho-tab *ngIf="printFilesEnabled">
        <a soho-tab-title tabId="{{TAB_ID_PRINTFILES}}" data-automation-id="lm-reports-catalog-printfiles-tab">{{printFilesTabTitle}}</a>
      </li>
    </ul>
  </div>
</div>

<div soho-tab-panel-container
    soho-busyindicator
    [blockUI]="true"
    displayDelay="100"
    class="lm-reports-catalog-wrapper"
    id="lm-reports-catalog-wrapper">

  <div soho-tab-panel *ngIf="displayDataGrid"
      tabId="{{TAB_ID_ALLREPORTS}}"
      id="{{TAB_ID_ALLREPORTS}}"
      class="scrollable">
    <lm-reports-list
        [reportsArray]="reportsArray$ | async"
        [categoriesByModule]="categoriesByModule$ | async"
        reportListId="all-list"
        (reportListEvent)="onReportListEvent($event)"
    ></lm-reports-list>
  </div>

  <div soho-tab-panel *ngIf="displayDataGrid && printFilesEnabled"
      tabId="{{TAB_ID_PRINTFILES}}"
      id="{{TAB_ID_PRINTFILES}}"
      class="scrollable">
      <div class="tab-list-container">
          <div class="columns nine">
              <div [ngStyle]="{'overflow': 'hidden'}">
                  <lm-list *ngIf="!doRetrievePrintFilesSpec && printFilesListUrlInfo"
                   [listUrlInfo]="printFilesListUrlInfo"
                   [listSpec]="printFilesListSpec"
                   [hasDependentData]="false"
                   [listInPagePaneTab]="true"
                   [pageHasContextForm]="false"
                   [pageHasTabs]="true"
                   (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                  ></lm-list>
              </div>
          </div>
            <div class="card columns three border-less lm-report-catalog-widget-container">
                <div class="lm-report-catalog-widget">
                    <div class="card columns twelve has-pager">
                        <div class="card-header">
                            <h2
                                tabIndex="0"
                                class="widget-title"
                                soho-tooltip [content]="'InProgress' | translate"
                                attr.id="in-process_widget_title"
                                attr.data-automation-id="lm-report-catalog-in-process-widget-title"
                            ><lm-widget-title [title]="'InProgress' | translate"></lm-widget-title></h2>
                            <div class="panelNavigation">
                                <button soho-button="icon" icon="refresh" (click)="onWidgetRefresh('print-queue')"></button>
                            </div>
                        </div>
                        <div class="card-content" [ngStyle]="{'overflow': 'hidden'}">
                              <lm-list #LMPrintQueueListComponent  *ngIf="!doRetrievePrintFilesSpec && printQueueListUrlInfo"
                               [listUrlInfo]="printQueueListUrlInfo"
                               [listSpec]="printQueueListSpec"
                               [hasDependentData]="false"
                               [listInPagePaneTab]="true"
                               [pageHasContextForm]="false"
                               [pageHasTabs]="true"
                               (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                              ></lm-list>
                        </div>
                    </div>
                </div>
                <div *ngIf="showScheduledWidget" class="lm-report-catalog-widget">
                    <div class="card columns twelve has-pager">
                        <div class="card-header">
                            <h2
                                    tabIndex="0"
                                    class="widget-title"
                                    soho-tooltip [content]="'Scheduled' | translate"
                                    attr.id="scheduled_widget_title"
                                    attr.data-automation-id="lm-report-catalog-scheduled-widget-title"
                            ><lm-widget-title [title]="'Scheduled' | translate"></lm-widget-title></h2>
                            <div class="panelNavigation">
                                <button soho-button="icon" icon="refresh" (click)="onWidgetRefresh('scheduled')"></button>
                            </div>
                        </div>
                        <div class="card-content" [ngStyle]="{'overflow': 'hidden'}">
                              <lm-list #LMPrintScheduledListComponent  *ngIf="!doRetrievePrintFilesSpec && printScheduleListUrlInfo"
                               [listUrlInfo]="printScheduleListUrlInfo"
                               [listSpec]="printScheuduleListSpec"
                               [hasDependentData]="false"
                               [listInPagePaneTab]="true"
                               [pageHasContextForm]="false"
                               [pageHasTabs]="true"
                               (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                              ></lm-list>
                        </div>
                    </div>
                </div>
          </div>
      </div>
  </div>
</div>

<div #modalPlaceholder id="modalPlaceholder"></div>
</ng-container>